/**
 *
 * @module entry
 * @desc {SDK.Services.Configuration} entry point.
 *
 */

import AccountManagerConfiguration from './accountManagerConfiguration';
import AdEngineManagerConfiguration from './adEngineManagerConfiguration';
import AdobeIdentityManagerConfiguration from './adobeIdentityManagerConfiguration';
import BamIdentityManagerConfiguration from './bamIdentityManagerConfiguration';
import BootstrapConfiguration from './bootstrapConfiguration';
import CommerceManagerConfiguration from './commerceManagerConfiguration';
import CommerceManagerExtrasMap from './commerceManagerExtrasMap';
import ConfigurationClient from './configurationClient';
import ConfigurationClientEndpoint from './configurationClientEndpoint';
import ConfigurationClientConfiguration from './configurationClientConfiguration';
import ConfigurationClientExtrasMap from './configurationClientExtrasMap';
import ConfigurationClientHostParams from './configurationClientHostParams';
import ConfigurationHostName from './configurationHostName';
import ContentManagerConfiguration from './contentManagerConfiguration';
import CustomerServiceManagerConfiguration from './customerServiceManagerConfiguration';
import DeviceManagerConfiguration from './deviceManagerConfiguration';
import PlatformProfileReference from './platformProfileReference';
import DrmManagerConfiguration from './drmManagerConfiguration';
import EnvironmentConfiguration from './../platforms/environmentConfiguration';
import LoggerConfiguration from './loggerConfiguration';
import MediaManagerConfiguration from './mediaManagerConfiguration';
import MediaManagerExtrasMap from './mediaManagerExtrasMap';
import PaywallManagerConfiguration from './paywallManagerConfiguration';
import PurchaseManagerConfiguration from './purchaseManagerConfiguration';
import SessionManagerConfiguration from './sessionManagerConfiguration';
import Platform from './platform';
import PurchaseManagerExtrasMap from './purchaseManagerExtrasMap';
import SdkSessionConfiguration from './sdkSessionConfiguration';
import ServiceConfiguration from './serviceConfiguration';
import ServiceDefinitionsConfiguration from './serviceDefinitionsConfiguration';
import SubscriptionManagerConfiguration from './subscriptionManagerConfiguration';
import TelemetryManagerConfiguration from './telemetryManagerConfiguration';
import TelemetryManagerExtrasMap from './telemetryManagerExtrasMap';
import TokenManagerConfiguration from './tokenManagerConfiguration';
import TokenManagerExtrasMap from './tokenManagerExtrasMap';

import RetryPolicy from './retryPolicy';
import HttpMethod from './httpMethod';

/**
 *
 * @typedef SDK.Services.Configuration
 * @type {Object}
 *
 * @property {AccountManagerConfiguration} AccountManagerConfiguration
 * @property {AdEngineManagerConfiguration} AdEngineManagerConfiguration
 * @property {AdobeIdentityManagerConfiguration} AdobeIdentityManagerConfiguration
 * @property {BamIdentityManagerConfiguration} BamIdentityManagerConfiguration
 * @property {BootstrapConfiguration} BootstrapConfiguration
 * @property {CommerceManagerConfiguration} CommerceManagerConfiguration
 * @property {CommerceManagerExtrasMap} CommerceManagerExtrasMap
 * @property {ConfigurationClient} ConfigurationClient
 * @property {ConfigurationClientEndpoint} ConfigurationClientEndpoint
 * @property {ConfigurationClientConfiguration} ConfigurationClientConfiguration
 * @property {ConfigurationClientExtrasMap} ConfigurationClientExtrasMap
 * @property {ConfigurationClientHostParams} ConfigurationClientHostParams
 * @property {ConfigurationHostName} ConfigurationHostName
 * @property {ContentManagerConfiguration} ContentManagerConfiguration
 * @property {CustomerServiceManagerConfiguration} CustomerServiceManagerConfiguration
 * @property {DeviceManagerConfiguration} DeviceManagerConfiguration
 * @property {PlatformProfileReference} PlatformProfileReference
 * @property {DrmManagerConfiguration} DrmManagerConfiguration
 * @property {EnvironmentConfiguration} EnvironmentConfiguration
 * @property {LoggerConfiguration} LoggerConfiguration
 * @property {MediaManagerConfiguration} MediaManagerConfiguration
 * @property {MediaManagerExtrasMap} MediaManagerExtrasMap
 * @property {PaywallManagerConfiguration} PaywallManagerConfiguration
 * @property {PurchaseManagerConfiguration} PurchaseManagerConfiguration
 * @property {SessionManagerConfiguration} SessionManagerConfiguration
 * @property {Platform} Platform
 * @property {PurchaseManagerExtrasMap} PurchaseManagerExtrasMap
 * @property {SdkSessionConfiguration} SdkSessionConfiguration
 * @property {ServiceConfiguration} ServiceConfiguration
 * @property {ServiceDefinitionsConfiguration} ServiceDefinitionsConfiguration
 * @property {SubscriptionManagerConfiguration} SubscriptionManagerConfiguration
 * @property {TelemetryManagerConfiguration} TelemetryManagerConfiguration
 * @property {TelemetryManagerExtrasMap} TelemetryManagerExtrasMap
 * @property {TokenManagerConfiguration} TokenManagerConfiguration
 * @property {TokenManagerExtrasMap} TokenManagerExtrasMap
 *
 * @property {RetryPolicy} RetryPolicy
 * @property {HttpMethod} HttpMethod
 *
 */

/**
 *
 * @type {SDK.Services.Configuration}
 *
 */
export default {

    AccountManagerConfiguration,
    AdobeIdentityManagerConfiguration,
    AdEngineManagerConfiguration,
    BamIdentityManagerConfiguration,
    BootstrapConfiguration,
    CommerceManagerConfiguration,
    CommerceManagerExtrasMap,
    ConfigurationClient,
    ConfigurationClientEndpoint,
    ConfigurationClientConfiguration,
    ConfigurationClientExtrasMap,
    ConfigurationClientHostParams,
    ConfigurationHostName,
    ContentManagerConfiguration,
    CustomerServiceManagerConfiguration,
    DeviceManagerConfiguration,
    PlatformProfileReference,
    DrmManagerConfiguration,
    EnvironmentConfiguration,
    LoggerConfiguration,
    MediaManagerConfiguration,
    MediaManagerExtrasMap,
    PaywallManagerConfiguration,
    PurchaseManagerConfiguration,
    SessionManagerConfiguration,
    Platform,
    PurchaseManagerExtrasMap,
    SdkSessionConfiguration,
    ServiceConfiguration,
    ServiceDefinitionsConfiguration,
    SubscriptionManagerConfiguration,
    TelemetryManagerConfiguration,
    TelemetryManagerExtrasMap,
    TokenManagerConfiguration,
    TokenManagerExtrasMap,

    RetryPolicy,
    HttpMethod

};



// WEBPACK FOOTER //
// ./src/services/configuration/entry.js